import script from "./TradingAccountTradesView.vue?vue&type=script&setup=true&lang=js"
export * from "./TradingAccountTradesView.vue?vue&type=script&setup=true&lang=js"

import "./TradingAccountTradesView.vue?vue&type=style&index=0&id=d829681a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d829681a"]])

export default __exports__